import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuthUser } from "../../lib/useAuthUser";
import { PerfilSettingsProvider } from "features/perfil/settings/store";
import { api } from "lib/api";
import { DEFAULT_DASHBOARD_PORTAL, normalizeDashboardPortal } from "features/dashboard/portal";
import PerfilLoadingPage from "./PerfilLoadingPage";
import RedirectStatusPage from "../../pages/main/Status/RedirectStatusPage";

export function PerfilGuard({ children }) {
  const user = useAuthUser();

  const q = useQuery({
    queryKey: ["route", "shouldGoDashboard", "v2", user?.uid ?? "anon"],
    queryFn: async () => {
      const data = await api("/dashboard/context");
      const portals = Array.isArray(data?.portals) ? data.portals : [];
      const firstPortal = normalizeDashboardPortal(portals[0]) || DEFAULT_DASHBOARD_PORTAL;
      return { goDashboard: true, portal: firstPortal };
    },
    enabled: user !== undefined && user !== null,
    staleTime: 10 * 60_000,
    retry: (count, err) => err?.status !== 401 && err?.status !== 403 && count < 1,
    refetchOnWindowFocus: false,
  });

  if (user === undefined) {
    return <PerfilLoadingPage message="Cargando sesión..." description="Estamos conectando tu cuenta de Arawaks." />;
  }

  if (user === null) {
    return <RedirectStatusPage to="/registro" eyebrow="Sesión necesaria" title="Vamos a iniciar sesión" description="Necesitas entrar a tu cuenta para consultar el perfil de tu familia." actionLabel="Ir a iniciar sesión" />;
  }

  if (q.isLoading) {
    return <PerfilLoadingPage message="Verificando acceso..." description="Estamos buscando el mejor lugar para continuar." />;
  }

  if (q.data?.goDashboard) {
    const targetPortal = normalizeDashboardPortal(q.data?.portal) || DEFAULT_DASHBOARD_PORTAL;
    return <RedirectStatusPage to={`/dashboard/${targetPortal}`} eyebrow="Cuenta del equipo" title="Tu espacio está en el dashboard" description="Detectamos que perteneces al equipo de Arawaks. Te llevaremos al portal que corresponde a tu función." actionLabel="Ir al dashboard" />;
  }

  return <PerfilSettingsProvider>{children}</PerfilSettingsProvider>;
}

export default PerfilGuard;
